Namespace 'Models.Builders'

class Models.Builders.InstagramMessageBuilder
  constructor: ->
    @time = null
    @senderId = null
    @recipientId = null
    @timestamp = null
    @messageId = null
    @reactions = null

  build: ->
    throw new Error('Not implemented')
